import { Card } from "reactstrap";
import { Link } from "react-router-dom";
// components Icons
import DashboardIcon from "../Components/Icons/DashboardIcon";
import OrganizationIcon from "../Components/Icons/OrganizationIcon";
import UserIcon from "../Components/Icons/UsersIcon";
import ArtformIcon from "../Components/Icons/ArtformIcon";
import TypeIcon from "../Components/Icons/TypeIcon";
import CategoryIcon from "../Components/Icons/CategoryIcon";
import SubCategoryIcon from "../Components/Icons/SubCategoryIcon";
import ProductIcon from "../Components/Icons/ProductIcon";
import WeaveTypeIcon from "../Components/Icons/WeaveTypeIcon";
// import Logo from "../../assets/images/D-3 1.jpg";
import CatalogIcon from "../../assets/images/icons8-catalog-50.png";
const SideMiniExpand = (props: any) => {
  const { logo, applicationUrl, location, handleClick, authUser } = props;

  return (
    <Card className="verticlemenuCard">
      <div className="LogoImage">
        {logo ? (
          <img
            src={logo}
            width="190px"
            height={"170px"}
            alt="Organization Logo"
          />
        ) : (
          <img
            src={applicationUrl}
            width="190px"
            height={"170px"}
            alt="Company Logo"
          />
        )}
      </div>
      <div className="parentList">
        <Link to="/dashboard">
          <div
            className={
              location?.pathname === "/dashboard"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
            onClick={() =>
              handleClick({
                name: "dashboard",
              })
            }
          >
            <DashboardIcon />
            <span className="verticleName">Dashboard</span>
          </div>
        </Link>
        <Link to="/products">
          <div
            className={
              location?.pathname === "/products" ||
              location?.pathname === "/createProduct" ||
              location.pathname.split("/")[1] === "view-product" ||
              location.pathname.split("/")[1] === "pre-viewProduct" ||
              location.pathname.split("/")[1] === "edit-product"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
            onClick={() => {
              handleClick({
                name: "products",
              });
            }}
          >
            <ProductIcon />
            <span className="verticleName">Products</span>
          </div>
        </Link>
        {authUser?.users?.role === "SUPER_ADMIN" ? (
          // ||
          // (authUser?.users?.role === "ORGANIZATION_ADMIN" &&
          //   process.env.REACT_APP_PERMISSIONS_ORG_ADMIN === "true") ||
          // (authUser?.users?.role === "ORGANIZATION_MANAGER" &&
          //   process.env.REAC_APP_PERMISSIONS_ORG_MANAGER === "true")
          <>
            <Link to="/organisation">
              <div
                className={
                  location?.pathname === "/organisation"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "organisation",
                  })
                }
              >
                <OrganizationIcon />
                <span className="verticleName">Organizations</span>
              </div>
            </Link>
          </>
        ) : (
          ""
        )}
        {authUser?.users?.role === "ORGANIZATION_ADMIN" ||
        authUser?.users?.role === "ORGANIZATION_MANAGER" ? (
          //    &&
          // authUser?.users?.organizationResponse?.organizationType ===
          //   "Manufacturer"
          <Link to="/catalogue">
            <div
              className={
                location?.pathname === "/catalogue"
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
            >
              <img src={CatalogIcon} width="25px" height="25px" alt="catalogue" />
              <span className="verticleName">Catalogue</span>
            </div>
          </Link>
        ) : (
          ""
        )}

        {/* {(authUser?.users?.role === "ORGANIZATION_ADMIN" ||
          authUser?.users?.role === "ORGANIZATION_MANAGER") &&
        authUser?.users?.organizationResponse?.organizationType ===
          "Design Agency" ? (
          <Link to="/manufactures">
            <div
              className={
                location?.pathname === "/manufactures"
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
            >
              <OrganizationIcon />
              <span className="verticleName">Manufacturers</span>
            </div>
          </Link>
        ) : (
          ""
        )} */}
        {authUser?.users?.role === "ORGANIZATION_ADMIN" ||
        authUser?.users?.role === "ORGANIZATION_MANAGER" ? (
          //    &&
          // authUser?.users?.organizationResponse?.organizationType ===
          //   "Manufacturer"
          <Link to="/party">
            <div
              className={
                location?.pathname === "/party"
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
            >
              <OrganizationIcon />
              <span className="verticleName">Party</span>
            </div>
          </Link>
        ) : (
          ""
        )}

        {/* <Link to="/Manufacturers">
          <div
            className={
              location?.pathname === "/Manufacturers"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
          >
            <OrganizationIcon />
            <span className="verticleName">Manufacturers</span>
          </div>
        </Link> */}
        <Link to="/users">
          <div
            className={
              location?.pathname === "/users" ||
              location?.pathname === "/createUser" ||
              location.pathname.split("/")[1] === "editUser" ||
              location.pathname.split("/")[1] === "viewUser"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
            onClick={() =>
              handleClick({
                name: "users",
              })
            }
          >
            <UserIcon />
            <span className="verticleName">Users</span>
          </div>
        </Link>
        {authUser?.users?.role === "SUPER_ADMIN" ||
        (authUser?.users?.role === "ORGANIZATION_ADMIN" &&
          process.env.REACT_APP_PERMISSIONS_ORG_ADMIN === "true") ||
        (authUser?.users?.role === "ORGANIZATION_MANAGER" &&
          process.env.REAC_APP_PERMISSIONS_ORG_MANAGER === "true") ? (
          <>
            <Link to="/artform">
              <div
                className={
                  location?.pathname === "/artform"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "artform",
                  })
                }
              >
                <ArtformIcon />
                <span className="verticleName">Artforms</span>
              </div>
            </Link>
            <Link to="/type">
              <div
                className={
                  location?.pathname === "/type"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "type",
                  })
                }
              >
                <TypeIcon />
                <span className="verticleName">Types</span>
              </div>
            </Link>
            <Link to="/category">
              <div
                className={
                  location?.pathname === "/category"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "category",
                  })
                }
              >
                <CategoryIcon />
                <span className="verticleName">Category</span>
              </div>
            </Link>
            <Link to="/sub-category">
              <div
                className={
                  location?.pathname === "/sub-category"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "sub-category",
                  })
                }
              >
                <SubCategoryIcon />
                <span className="verticleName">Sub-Category</span>
              </div>
            </Link>
            <Link to="/weave-type">
              <div
                className={
                  location?.pathname === "/weave-type"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "weave-type",
                  })
                }
              >
                <WeaveTypeIcon />
                <span className="verticleName">Weave Types</span>
              </div>
            </Link>
          </>
        ) : (
          ""
        )}
      </div>
    </Card>
  );
};

export default SideMiniExpand;
